import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ChangeHistoryComponent } from '../change-history-component/change-history-component';
import { AppConfig } from '../../../app/app.config';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';

@IonicPage()
@Component({
  selector: 'page-change-history',
  templateUrl: 'change-history.html',
})
export class ChangeHistoryPage {
  @ViewChild('changeHistoryComponent') changeHistoryComponent: ChangeHistoryComponent;

  config = AppConfig.settings;

  snapshotSummaryId: number;

  // controls the daily log date that we shot the audit records for, has no bearing on creationTime for the audit entities
  startDailyLogDate: PtLuxonDate;

  // will only show records created after the below date, if not null
  creationTimeFilterDate: PtLuxonDate;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private supportContextService: SupportContextService,
  ) {
    this.startDailyLogDate = this.navParams.get('startDailyLogDate');
    this.creationTimeFilterDate = this.navParams.get('creationTimeFilterDate');
    this.snapshotSummaryId = this.navParams.get('snapshotSummaryId');
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {
    this.supportContextService.setComponentContext(SupportContextKey.ChangeHistory, 'Change History', 'ChangeHistoryPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-history/change-history/change-history.ts